export const decodeProfileForPackage = (profile) => {
    return {
        accessLevel: profile.access_level,
        email: profile.email,
        firstName: profile.first_name,
        lastName: profile.last_name
    };
};
export const decodeProfile = async (profile, getImageUrl) => {
    const presignedUrl = profile.profile_logo && profile.profile_logo.length > 0 && getImageUrl
        ? await getImageUrl(profile.profile_logo)
        : "";
    return {
        created: new Date(profile.created),
        disabledNotificationTypes: profile.disabled_notification_types ?? [],
        email: profile.email,
        emailNotifications: profile.email_notifications,
        federatedUser: profile.federated_user,
        firstName: profile.first_name,
        id: profile.profile_id,
        isAdmin: profile.is_admin,
        isContractor: profile.is_contractor,
        isSetup: profile.is_setup,
        lastName: profile.last_name,
        mfaEnrolled: profile.mfa_enrolled,
        organisationId: profile.organisation_id,
        // Derived, decode-only (flattened from the org relation; not re-encoded).
        // A UX hint so the frontend can route to enrolment without a flash of the
        // app — NOT the security control. Enforcement is the server-side guard
        // reading the DB-joined organisation on every request, so if this is
        // undefined the worst case is a cosmetic flash before the backend 403s.
        organisationMfaEnabled: profile.organisation?.mfa_enabled,
        profileLogo: presignedUrl,
        profileLogoSrc: profile.profile_logo,
        status: profile.status
    };
};
export const encodeProfile = (profile) => {
    return {
        created: new Date(profile.created),
        // Omitted, not defaulted to []. The backend's upsertProfile writes this column
        // only when the payload carries it, so that a write which knows nothing about
        // notification preferences cannot clear them. Encoding undefined as [] would
        // look like "the user switched everything back on" and defeat that guard for
        // any caller that hand-builds a ProfileLineItem.
        ...(profile.disabledNotificationTypes !== undefined && {
            disabled_notification_types: profile.disabledNotificationTypes
        }),
        email: profile.email,
        email_notifications: profile.emailNotifications,
        federated_user: profile.federatedUser,
        first_name: profile.firstName,
        is_admin: profile.isAdmin,
        is_contractor: profile.isContractor,
        is_setup: profile.isSetup,
        last_name: profile.lastName,
        mfa_enrolled: profile.mfaEnrolled,
        organisation_id: profile.organisationId,
        profile_id: profile.id,
        profile_logo: profile.profileLogoSrc,
        status: profile.status
    };
};
